import { render, staticRenderFns } from "./NpRecognitionApproval.vue?vue&type=template&id=8cbcd0d4"
import script from "./NpRecognitionApproval.vue?vue&type=script&lang=js"
export * from "./NpRecognitionApproval.vue?vue&type=script&lang=js"
import style0 from "./NpRecognitionApproval.vue?vue&type=style&index=0&id=8cbcd0d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports